import React from "react";
import NCLOGO from "./Assessts/Logo.png";
import { Row, Col } from "react-bootstrap";
import "./Footer.scss";
import { IoLocationOutline } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import { LiaPhoneVolumeSolid } from "react-icons/lia";

import { TiSocialFacebook } from "react-icons/ti";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { TiSocialLinkedin } from "react-icons/ti";
import { FiYoutube } from "react-icons/fi";
const Footer = () => {
    return (
        <div className="container-fluid Footer-mainDiv  ">
            <Row>
                <Col className="dflex alignitems JCCenter"><img src={NCLOGO} alt="NCLLogo" className="LOGO" /></Col>
                <Col className="dflex alignitems JCCenter">
                    <div className="FFollow dflex alignitems flexd-column gap-3">
                        <div>Follow us</div>
                        <div className="dflex gap-3"> <TiSocialFacebook /> <FaXTwitter /> <FaInstagram /> <TiSocialLinkedin /> <FiYoutube /></div>
                    </div>
                </Col>
                <Col className="dflex alignitems JCCenter">
                    <div className="FAddress dflex flexd-column gap-2">
                        <div className="dflex gap-3"><span><IoLocationOutline /> </span> <span>316, 3rd Floor, Model House,
                            6-3-458/A/1, Dwarakapuri, Punjagutta,
                            Hyderabad, Telangana 500082</span></div>
                        <div className="dflex gap-3"><span><MdMailOutline /> </span><span>indiancl@northsouth.org</span></div>
                        <div className="dflex gap-3"><span><LiaPhoneVolumeSolid /> </span><span>040 2335 6368</span></div>
                    </div>
                </Col>
                <div className="dflex alignitems JCCenter  w-100 flexd-column">
                <hr className="w-75" style={{opacity:1}} />
                <div className="copyRight"> © 2026 North South Foundation. All rights reserved.  <span>Contact Us</span> <span> Privacy Policy</span> </div> </div>
            </Row>
        </div>
    )
}
export default Footer;